import { Component, EventEmitter, Output, OnInit, OnDestroy, Input, AfterViewInit, inject } from '@angular/core';
import {
  IActivo,
  ICoordenadas,
  IFilter,
  IQueryParam,
  IReporteGenerico,
  Trip,
} from 'modelos/src';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-activo-recorrido',
  templateUrl: './activo-recorrido.component.html',
  styleUrl: './activo-recorrido.component.scss',
  standalone: false,
})
export class ActivoRecorridoComponent implements AfterViewInit {
  dialog = inject(MatDialog);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);

  // si no el mapa al principio no funca, "No juzguéis o seréis juzgados"
  public si: boolean = true;
  public interaccionesBusqueda: Trip[] = [];
  public interaccionesBusquedaSelected: Trip;
  @Output() public interaccionesBusquedaSelectedChange = new EventEmitter<
    [number, number][]
  >();
  @Output() public loading = new EventEmitter<boolean>();
  public displayedColumns: string[] = ['Recorridos'];
  public buscando: boolean = false;
  public date?: string = '';

  public query: IQueryParam = {
    sort: 'nombre',
    page: 0,
    includeChildren: true,
    childrenLevel: 0,
  };

  @Input() public activo: IActivo = null;

  public async listarViajes() {
    if (this.si) {
      this.si = false;
      return;
    }
    if (!this.date || !this.activo) {
      this.interaccionesBusqueda = [];
      return;
    }
    const date = new Date(this.date);
    const start = new Date(date.getTime()).toISOString();
    const end = new Date(date.getTime() + 24 * 60 * 60 * 1000).toISOString();
    await this.listarReportes(start, end);
  }

  public async listarReportes(start: string, end: string) {
    this.loading.emit(true);
    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: this.activo._id!,
      'valores.timestamp': {
        $gte: start,
        $lte: end,
      },
    } as any;
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'timestamp',
      includeChildren: true,
    };
    try {
      const data = await firstValueFrom(this.lista2.snappeadosGenericos(query));
      const res: [number, number][] = [];
      let cord1: [number, number] | undefined;
      let distancia;
      data.map((c, index) => {
        const coord = c; // data ya es [number, number][]
        if (!cord1) {
          cord1 = coord;
        } else {
          distancia = this.helper.distanciaEntrePuntos(cord1, coord);
          if (distancia > 20) {
            res.push(cord1);
            cord1 = coord;
          }
          if (index === data.length - 1) {
            res.push(cord1);
          }
        }
      });
      this.interaccionesBusquedaSelectedChange.emit(res);
    } catch (error) {
      if (
        (error as any).error?.message ===
        'No se encontraron reportes para el viaje'
      )
        this.helper.notifWarn('No hay reportes para la fecha elegida');
      else console.warn('Error al listar', error);
      this.interaccionesBusquedaSelectedChange.emit([]);
    }
  }
  async ngAfterViewInit(): Promise<void> {
    this.date = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
    await this.listarViajes();
  }

  // public async onRecorridoSelected(trip: Trip, expanded: boolean) {
  //   if (expanded) {
  //     this.interaccionesBusquedaSelected = trip;
  //     this.listarReportes();
  //   }
  // }
}
